import { render, staticRenderFns } from "./FeaturedPlayerImporter.vue?vue&type=template&id=0f3f359e"
import script from "./FeaturedPlayerImporter.vue?vue&type=script&lang=ts"
export * from "./FeaturedPlayerImporter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports